import { transition } from "@huub-web/ui/utils/transition";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = recipe({
  base: {
    position: "relative",
    width: "100%",
    height: "100%",
    opacity: 0,
    transition: transition("opacity"),
  },
  variants: {
    loaded: {
      true: {
        opacity: 1,
      },
    },
  },
});
